module.exports = __webpack_public_path__ + "images/skillz-navbar-logo-aa5dba3c5da8679132d7c8defd6cc4b9.svg";